import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Reconciliation from './reconciliation';
import TransactionDetail from './transactiondetail';
import ReconciliationCycle from './reconciliationcycle';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import { XTabNav } from '@/components/xqxc_ui';
import { TabType } from './types';

const tabList = [
    { id: TabType.Reconciliation, label: '企业对账单' },
    { id: TabType.TransactionDetail, label: '企业交易明细' },
    { id: TabType.ReconciliationCycle, label: '企业对账周期' }
];

const Index = (props) => {
    const [curTabID, setCurTabID] = useState(sessionStorage.getItem('enterprisereconciliation') || TabType.Reconciliation);

    useEffect(() => {
        sessionStorage.getItem('enterprisereconciliation') && sessionStorage.removeItem('enterprisereconciliation');
        props.setBreadcrumbPaths(props.match);
    }, []);

    return (
        <div className={styles.flexBoxContainer}>
            <XTabNav renderData={tabList} onChange={setCurTabID} activedID={curTabID} />
            {curTabID === TabType.Reconciliation && <Reconciliation key={curTabID} curTabID={curTabID} {...props} />}
            {curTabID === TabType.TransactionDetail && <TransactionDetail key={curTabID} curTabID={curTabID}  {...props} />}
            {curTabID === TabType.ReconciliationCycle && <ReconciliationCycle key={curTabID} curTabID={curTabID}  {...props} />}
        </div>
    );
};

Index.propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,//路由对象
    setBreadcrumbPaths: PropTypes.func
};

export default connect(null, { setBreadcrumbPaths })(Index);